/** Build a transparent PNG data-URI of typed name / initials. */
export function typedSignatureDataUri(text, { italic = true } = {}) {
  const value = (text || '').trim();
  if (!value) return '';
  const canvas = document.createElement('canvas');
  canvas.width = 640;
  canvas.height = 160;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#071B34';
  ctx.textBaseline = 'middle';
  const size = value.length <= 4 ? 72 : value.length <= 14 ? 48 : 36;
  const style = italic ? 'italic ' : '';
  // Prefer fonts that render script-like on macOS / Windows / Linux.
  ctx.font = `${style}${size}px "Segoe Script", "Apple Chancery", "Brush Script MT", "Comic Sans MS", cursive, serif`;
  const metrics = ctx.measureText(value);
  const x = Math.max(24, (canvas.width - metrics.width) / 2);
  ctx.fillText(value, x, canvas.height / 2 + 4);
  // Subtle underline like a signature baseline
  ctx.strokeStyle = 'rgba(7, 27, 52, 0.25)';
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.moveTo(x - 8, canvas.height / 2 + size * 0.45);
  ctx.lineTo(x + metrics.width + 8, canvas.height / 2 + size * 0.45);
  ctx.stroke();
  return canvas.toDataURL('image/png');
}

export function fileToDataUri(file) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type.startsWith('image/')) {
      reject(new Error('Please choose an image file'));
      return;
    }
    if (file.size > 280000) {
      reject(new Error('Image must be under 280 KB'));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('Could not read file'));
    reader.readAsDataURL(file);
  });
}
